import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Mumbai, Maharashtra",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4ef51b0-1763295821469.png",
    avatarAlt: "Professional headshot of Indian man with short black hair wearing blue shirt and glasses",
    text: "F.I.R.E by Dexterr helped me plan my retirement with realistic Indian inflation rates. Now I\'m confident about my financial future.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Bangalore, Karnataka",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc96d634-1763295460493.png",
    avatarAlt: "Professional headshot of Indian woman with long black hair wearing traditional red saree",
    text: "The goal planning feature is excellent. I\'ve successfully planned for my daughter\'s education and our home purchase.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    location: "Ahmedabad, Gujarat",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17de2c40c-1763294952850.png",
    avatarAlt: "Professional headshot of Indian man with short black hair wearing white formal shirt",
    text: "Simple, intuitive, and specifically designed for Indian financial planning. Highly recommended for young professionals.",
    rating: 5
  }];


  const securityFeatures = [
  {
    icon: "Shield",
    title: "Bank-Grade Security",
    description: "Your data is encrypted with 256-bit SSL encryption"
  },
  {
    icon: "Lock",
    title: "Privacy Protected",
    description: "We never share your personal information with third parties"
  },
  {
    icon: "CheckCircle",
    title: "Trusted by 50,000+ Indians",
    description: "Join thousands of users planning their financial future"
  }];


  return (
    <div className="space-y-8">
      <div className="bg-card rounded-xl p-6 border border-border shadow-card">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center">
            <Icon name="Users" size={20} className="text-success" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Trusted by Indians</h3>
            <p className="text-sm text-muted-foreground">Real stories from real users</p>
          </div>
        </div>

        <div className="space-y-4">
          {testimonials?.map((testimonial) =>
          <div key={testimonial?.id} className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-start gap-3 mb-2">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }} />

                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <h4 className="font-medium text-sm text-foreground truncate">
                      {testimonial?.name}
                    </h4>
                    <div className="flex gap-0.5 flex-shrink-0">
                      {[...Array(testimonial?.rating)]?.map((_, i) =>
                    <Icon key={i} name="Star" size={12} className="text-warning fill-warning" />
                    )}
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">{testimonial?.location}</p>
                  <p className="text-sm text-foreground leading-relaxed">{testimonial?.text}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-card rounded-xl p-6 border border-border shadow-card">
        <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="ShieldCheck" size={20} className="text-primary" />
          Your Security Matters
        </h3>
        
        <div className="space-y-4">
          {securityFeatures?.map((feature, index) =>
          <div key={index} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm text-foreground mb-1">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground leading-relaxed">{feature?.description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-accent/10 rounded-xl p-4 border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-accent flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground leading-relaxed">
              <strong>Indian Context:</strong> Our calculations use Indian inflation rates, tax structures, and retirement norms to provide accurate financial projections tailored for Indian users.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TrustSignals;